// tslint:disable

import * as Cookie from 'js-cookie';
import { get } from 'lodash';
import * as React from 'react';
import { TemplateItem, Templates } from '../../__templates/templates';
import { Authorize } from '../libs/authorize';

export class EntityDetailsComponent extends React.Component<any> {
    private templates: Templates = new Templates();
    private entity: string;
    private entityId: string;
    private isCreate: boolean;
    private isUpdate: boolean;
    private isList: boolean;
    private isModal: boolean;
    private template: TemplateItem;

    componentWillMount() {
        this.entity = this.props.entity || get(this.props, 'match.params.entity');

        this.entityId = this.props.entityId || get(this.props, 'match.params.id');

        this.reload(this.entity, this.entityId);
    }

    reload(entity: any, entityId: any) {

        this.entity = entity;

        this.entityId = entityId;

        this.isCreate = this.entityId === 'create';

        this.isList = !this.entityId && !!this.entity;
        this.isUpdate = !!this.entityId && (this.entityId !== 'create');

        try {
            const site = JSON.parse(Cookie.get('site') as string);

            if (!site.code) {
                throw new Error('no.site.code');
            }

            this.template = this.templates.getTemplate(this.entity, this.entityId ? 'details' : 'list', site.code);
        }
        catch (err) {
            this.template = this.templates.getTemplate(this.entity, this.entityId ? 'details' : 'list');
        }

        this.isModal = !!this.props.isModal;
        Authorize.authorize();

        this.forceUpdate();

    }

    render() {
        if (!this.template) {
            return <h2>404</h2>;
        }

        return React.createElement(this.template.component, {
            ENTITY: this.entity,
            ENTITY_ID: this.entityId,
            PARENT_CONTEXT: this,
            IS_CREATE: this.isCreate,
            IS_UPDATE: this.isUpdate,
            IS_LIST: this.isList,
            IS_MODAL: this.isModal,
            ON_CREATE_SUCCESSFUL: this.props.onCreateSuccessful || (() => null),
            ON_UPDATE_SUCCESSFUL: this.props.onUpdateSuccessful || (() => null),
            ON_CHANGE$: this.props.onChange$,
            CONFIG: this.props.config || {}
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/entity-details.component.tsx